import { useEffect, useState } from 'react';
import Modal from '../../components/Modal';
import { normalizeId } from '../../utils/formatters';
import { formatUserFullName } from '../../utils/users';
import logger from '../../utils/logger';

// Бэкенд принимает получателя только с ролью администратора кабинета.
const TRANSFER_RECIPIENT_ROLES = new Set(['admin', 'admin_api']);

function TransferCabinetModal({ cabinet, request, currentUserId, busy, onClose, onSubmit }) {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [recipientId, setRecipientId] = useState('');

  useEffect(() => {
    if (!cabinet?.id) return undefined;
    let cancelled = false;
    setLoading(true);
    setRecipientId('');
    request(`/api/v1/access/marketplaces/${cabinet.id}/memberships`, {})
      .then(data => { if (!cancelled) setMembers(data || []); })
      .catch(error => { logger.error(error); if (!cancelled) setMembers([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [cabinet?.id, request]);

  if (!cabinet) return null;

  const candidates = members.filter(member => member.user
    && TRANSFER_RECIPIENT_ROLES.has(member.role)
    && normalizeId(member.user.id) !== normalizeId(currentUserId));

  const handleSubmit = event => {
    event.preventDefault();
    if (!recipientId) return;
    onSubmit(recipientId);
  };

  return <Modal open onClose={onClose} title="Передать кабинет">
            <p className="muted">
                Кабинет: <strong>{cabinet.account_name || cabinet.name || cabinet.id}</strong>.
                Получатель станет владельцем после того, как примет запрос; вы останетесь администратором.
            </p>
            {loading ? <p className="muted">Загрузка сотрудников…</p> : candidates.length === 0 ? <p className="muted">
                    Передать можно только сотруднику с ролью «Администратор» в этом кабинете.
                    Сначала пригласите его или повысьте роль в «Управлении сотрудниками кабинета».
                </p> : <form className="modal__form" onSubmit={handleSubmit}>
                    <label>
                        Новый владелец
                        <select className="modal__input" value={recipientId} onChange={event => setRecipientId(event.target.value)}>
                            <option value="">Выберите сотрудника</option>
                            {candidates.map(member => {
          const name = formatUserFullName(member.user);
          return <option key={member.id} value={member.user.id}>
                                        {name ? `${name} — ${member.user.email}` : member.user.email}
                                    </option>;
        })}
                        </select>
                    </label>
                    <div className="modal__actions">
                        <button type="button" className="ghost" onClick={onClose}>Отмена</button>
                        <button type="submit" disabled={busy || !recipientId}>Отправить запрос</button>
                    </div>
                </form>}
        </Modal>;
}
export default TransferCabinetModal;
